'use client';

import React, { useState } from 'react';
import { TransactionDetailsTab } from '@/app/dashboard/deposit/components/transaction-details-tab';
import { TransactionJsonTab } from '@/app/dashboard/deposit/components/transaction-json-tab';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import { getUi, hideDrawerState } from '@/store/reducers/ui-slice';
import { Divider, Tab, Tabs } from '@mui/material';
import { Stack } from '@mui/system';

import { GeneralDrawer, TransactionTab } from '@/types/general';

import DrawerTemplate from '../core/drawer-template';

export default function TransactionDetailsDrawer(): React.JSX.Element {
  const { drawerState } = useAppSelector(getUi);
  const dispatch = useAppDispatch();

  const [tabValue, setTabValue] = useState(TransactionTab.DETAILS);
  const tabList = [
    {
      id: TransactionTab.DETAILS,
      label: 'Details',
      content: <TransactionDetailsTab />,
    },
    {
      id: TransactionTab.JSON,
      label: 'JSON',
      content: <TransactionJsonTab />,
    },

    // {
    //   id: PlayerTab.TECH_SUPPORT,
    //   label: 'Tech Support',
    //   content: <Typography>Soon</Typography>,
    // },
    // {
    //   id: PlayerTab.SETTINGS,
    //   label: 'Player Settings',
    //   content: <PlayerSettingsTab />,
    // },
  ];

  const handleChange = (event: React.SyntheticEvent, newValue: TransactionTab): void => {
    setTabValue(newValue);
  };

  return (
    <DrawerTemplate
      open={drawerState.TRANSACTION_DETAILS}
      onClose={() => dispatch(hideDrawerState(GeneralDrawer.TRANSACTION_DETAILS))}
      title="Transaction Details"
      width="830px"
    >
      <Tabs value={tabValue} onChange={handleChange}>
        {tabList.map((item) => (
          <Tab key={item.id} label={item.label} value={item.id} />
        ))}
      </Tabs>
      <Divider />
      {tabList.map((item) => (
        <Stack sx={{ pt: 2, display: item.id === tabValue ? 'flex' : 'none' }} key={item.id}>
          {item.content}
        </Stack>
      ))}
    </DrawerTemplate>
  );
}
